/**
 * @name setHeaderScrollClass
 * @description スクロールでヘッダーに状態クラスを付与する
 */
export function setHeaderScrollClass() {
  const header = document.querySelector('.header');
  if (!header) return;

  const threshold = 1;

  const update = () => {
    if (window.scrollY >= threshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
}
